export default __webpack_public_path__ + "static/logo-53d762025176421edf41c488622d8d52.png";